'use strict'

export default {
 'title': 'Commonwealth Games 2026 - medals, schedule, Aussies',
 'name': 'CommonwealthGames2026',
 'assetPath': {
  'development': 'http://localhost:8080/nnd/',
  'staging': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/data/tester/',
  // 'production': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/',
  'production': 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/nnd/',
  'preview': '/'
 },
 'deployPath': {
  'development': '../nnd/',
  'staging': '../tester/',
  'production': '../nnd/',
  'preview': '../nnd/'
 }
}
